export abstract class ErrorBase implements Error {

    constructor(name: string, message: string) {
        this.name = name;
        this.message = message;
    }

    public name: string = null;

    public message: string = null;

}
